<a class="card" [href]="pcpInfo && pcpInfo.href ? pcpInfo.href : '#'">
  <div class="flex-container d-flex m-3 m-lg-4 align-items-start">
    <ng-template #profileImage>
      <om-profile-bubble
        @enter
        [profile]="pcpInfo.provider"
        [colorCombo]="pcpInfo.provider.id"
        size="semi-large"
        class="d-none d-lg-block"
      ></om-profile-bubble>

      <om-profile-bubble
        @enter
        [profile]="pcpInfo.provider"
        [colorCombo]="pcpInfo.provider.id"
        size="large"
        class="d-block d-lg-none"
      ></om-profile-bubble>
    </ng-template>

    <ng-template #placeholderSvg>
      <div class="svg-container ml-2 ml-lg-0"><om-svg-choose-pcp></om-svg-choose-pcp></div>
    </ng-template>

    <ng-template #loadingState>
      <om-profile-bubble size="semi-large" class="d-none d-lg-block"></om-profile-bubble>
      <om-profile-bubble size="large" class="d-block d-lg-none"></om-profile-bubble>

      <div class="ml-lg-4">
        <div class="mb-2 placeholder placeholder-title"></div>
        <div class="mb-1 placeholder"></div>
        <div class="mb-1 placeholder"></div>
        <div class="mb-1 placeholder"></div>
      </div>
    </ng-template>

    <ng-container *ngIf="isSuccessState(pageState); else loadingState">
      <ng-container *ngIf="hasPcp; then profileImage; else placeholderSvg"></ng-container>

      <div class="ml-lg-4" @enter>
        <p class="card-title mb-1">{{ pcpInfo.title }}</p>
        <p class="card-text mb-1" *ngIf="pcpInfo.subtitle">{{ pcpInfo.subtitle }}</p>

        <ng-container *ngIf="hasPcp; then address; else choosePcpInfo"></ng-container>

        <ng-template #address>
          <!-- prettier-ignore -->
          <address class="card-text">{{ pcpInfo.details }}
            <a *ngIf="pcpInfo.phoneNumber" [href]="'tel:' + pcpInfo.phoneNumber" class="phone-number" (click)="$event.stopPropagation()">{{
              pcpInfo.phoneNumber
            }}</a>
          </address>
        </ng-template>

        <ng-template #choosePcpInfo>
          <div class="card-text mb-3">{{ pcpInfo.details }}</div>
        </ng-template>

        <div class="btn btn-outline-primary choose-pcp" *ngIf="!hasPcp">Choose Provider</div>
      </div>
    </ng-container>
  </div>
</a>
